




















































































































































































































































































































































import { Component, Emit, Prop } from 'vue-property-decorator';
import Mixin from '@/mixin';
import { User } from '@/store/models';
import { validationMixin, Vuelidate } from 'vuelidate';
import { TUser, userValidator } from '@/config/validation/user-validator';
import coachService from '@/services/common/coach.service';
import messageModule from '@/store/modules/common/message.module';
import { MessageType } from '@/config/enum';
import coachModule from '@/store/modules/common/coach.module';
import VMessage from '@/components/items/VMessage.vue';
import VDatePicker from '@/components/items/VDatePicker.vue';
import VPasswordInput from '@/components/items/VPasswordInput.vue';
import VPopupResetPassword from '@/components/popup/VPopupResetPassword.vue';
import { dateFilter } from '@/config/filter';
import moment, { now } from 'moment';
import dataCountries from '@/data/countries.json';

@Component({
  name: 'VModalCoachItem',
  components: { VPopupResetPassword, VPasswordInput, VDatePicker, VMessage },
  mixins: [validationMixin],
  validations: userValidator
})
export default class VModalCoachItem extends Mixin {
  @Prop({ required: false }) user?: User;
  @Prop({ required: true }) isShowModal?: boolean;
  public coach = this.user?.coach;
  public showResetPassWord = false;
  public period = '';
  public params: User|undefined = this.user;

  public selectDate(e) {
    if (this.user) {
      if (e.target.value) {
        this.user.subStartDate = dateFilter(now());
        this.user.subEndDate = dateFilter(
          moment()
            .add(e.target.value, 'days')
            .toDate()
        );
      } else {
        this.user.subStartDate = '';
        this.user.subEndDate = '';
      }
    }
  }

  get message() {
    return messageModule.message;
  }

  get countriesOptions() {
    const data = dataCountries.countries || [];
    return data;
  }

  get messageType() {
    return messageModule.type;
  }

  get vUser() {
    return (this.$v as Vuelidate<TUser>).params;
  }

  get allowSubmit() {
    return !(this.vUser?.$error || this.vUser?.$invalid);
  }

  public async save() {
    this.vUser?.$touch();
    if (this.allowSubmit) {
      if (this.coach?.id) {
        // Update a coach
        await coachService.updateCoach(this.user?.id || -1, {
          firstName: this.user?.coach?.firstName || '',
          lastName: this.user?.coach?.lastName || '',
          jobTitle: this.user?.coach?.jobTitle || '',
          companyName: this.user?.coach?.companyName || '',
          subStartDate: this.user?.subStartDate || '',
          subEndDate: this.user?.subEndDate || '',
          department: this.user?.coach?.department || '',
          accountStatus: this.user?.accountStatus || 0,
          password: this.user?.initialPassword || '',
          country: this.params?.country || '',
        });
        await coachModule.loadCoaches(this.$route.query);
        await messageModule.showMessage({
          message: `${this.coach?.firstName} ${this.coach?.lastName} has been updated successfully`,
          type: MessageType.info
        });
        this.$emit('save');
      } else {
        // Add new coach
        let params: any = {
          firstName: this.coach?.firstName || '',
          lastName: this.coach?.lastName || '',
          email: this.coach?.email || '',
          initialPassword: this.user?.initialPassword || '',
          jobTitle: this.coach?.jobTitle,
          companyName: this.coach?.companyName,
          department: this.coach?.department,
          country: this.params?.country || '',
        }
        if (this.user?.subStartDate && this.user?.subEndDate) {
          params = {
            ...params,
            subStartDate: this.user?.subStartDate,
            subEndDate: this.user?.subEndDate,
          }
        }
        await coachService.createCoach(params);
        await coachModule.loadCoaches(this.$route.query);
        await messageModule.showMessage({
          message: `${this.coach?.firstName} ${this.coach?.lastName} has been created successfully`,
          type: MessageType.info
        });
        this.$emit('save');
      }
    }
  }

  @Emit()
  public cancel() {}

  public resetPassword(e) {
    e.preventDefault();
    this.showResetPassWord = !this.showResetPassWord;
  }

  mounted() {
    this.coach = this.user?.coach;
    this.params = this.user;
    if (this.params) {
      this.params.country = this.user?.country ? this.user?.country : '';
    }
    if (this.coach?.id && this.user) {
      this.user.passwordConfirmation = 'passwordConfirmation';
      this.user.password = 'passwordConfirmation';
    }
  }
}
